module.exports = __webpack_public_path__ + "img/Poster_1345CommonSpace.8b08577f.png";